/* eslint-disable react/react-in-jsx-scope */
import Navigation from "@/components/layout/Navigation";
import { FC, ReactNode, useEffect } from "react";
import { useSession } from "@/broadcastChannel/useSession";
import { useNavigate } from "react-router-dom";

const Layout: FC<{ children: ReactNode }> = ({ children }) => {
  
  return (
    <div id="container-main" className="relative">
      <Navigation />
      {children}
    </div>
  );
};

export default Layout;
